import { IllegalStateError, type KeyValuePersistence } from '@amazon/vinyl-util'
import { getPlaybackEnv } from './playbackEnvRef'

/** A `createPersistentItem` persistence over the installed env's store, read at call time. */
export const storePersistence: KeyValuePersistence<string> = {
    get: async (key) => getPlaybackEnv().store.getItem(key),
    set: async (key, value) => getPlaybackEnv().store.setItem(key, value),
    remove: async (key) => getPlaybackEnv().store.removeItem(key),
    clear: () => Promise.reject(new IllegalStateError('A KeyValueStore cannot be cleared')),
}
